export default "__VITE_ASSET__DDRU0O1s__"